<template>
    <div style="background: #FFFFFF;">
        <top-carousel></top-carousel>
        <div class="container recruit-content">
            <div class="panel">
                <div class="panel-heading">
                    <h3 class="panel-title">高级暖通动力工程师</h3>
                </div>
                <div class="panel-body">
                    <div class="duty-desc">职位描述</div>
                    <ul>
                        <li class="pos-desc">岗位职责：</li>
                        <li>
                            1、独立完成大型制冷站、锅炉房以及空调系统项目专业设计、系统节能分析、控制算法、评估报告、方案制作及图纸审核；
                        </li>
                        <li>
                            2、独立完成大型空压系统项目专业设计、系统节能分析、控制算法、评估报告、方案及图纸审核报告，出具设计说明文件；
                        </li>
                        <li>3、独立承担本专业与业主方、合作方的协调工作；</li>
                        <li>4、熟练掌握本专业常用系统的应用；</li>
                        <li>5、熟悉本专业常用设备的性能；</li>
                        <li>
                            6、熟练掌握公司及行业相关的规范及标准，严格执行各质量体系标准；
                        </li>
                        <li>
                            7、严格执行设计规范，规范设计，仔细审核，防止发生设计差错。
                        </li>
                        <li class="pos-desc">任职资格：</li>
                        <li>
                            1、211/985大学自动化控制、暖通等相关专业研究生及以上学历，5年及以上工作经验；
                        </li>
                        <li>
                            2、熟练使用电脑，具备良好的中英文读写和口头沟通能力；
                        </li>
                        <li>3、对MATLAB或python精通者优先；</li>
                        <li>
                            4、对制冷站、锅炉房以及空调系统或空压系统其中一项精通即可，精通两个系统及以上优先；
                        </li>
                        <li>
                            5、具备独立工作分析和解决问题的能力，能与客户、公司技术人员进行有效沟通。
                        </li>
                    </ul>
                </div>
            </div>
            <!-- <div class="panel">
                <div class="panel-heading">
                    <h3 class="panel-title">暖通工程师</h3>
                </div>
                <div class="panel-body">
                    <div class="duty-desc">职位描述</div>
                    <ul>
                        <li class="pos-desc">技能要求：</li>
                        <li>
                         空调，空压、除尘、动力、锅炉系统设计
                        </li>
                        <li class="pos-desc">岗位职责：</li>
                        <li>
                            1、负责水系统、空调系统、锅炉系统、空压系统设计、现场施工及运行管理工作；
                        </li>
                        <li>
                            2、负责空调系统、锅炉系统、空压系统运行管理数据分析；
                        </li>
                        <li>3、负责水系统、空调系统、锅炉系统、空压系统及系统控制流程的编写及整理工作；</li>
                        <li>4、负责水系统、空调系统、锅炉系统、空压系统的节能改造和设计工作。</li>
                        <li>5、组织编制设计图纸、材料样板、施工图纸、竣工图纸、资料（法律文件）等，并进行校核。</li>
                        <li>
                            6、根据要求按时完成所需设计方案及图纸的校核、出图工作。
                        </li>
                        <li class="pos-desc">任职资格：</li>
                        <li>
                            1、建筑环境与设备工程、热能与动力工程、供热通风与空调工程、制冷与冷藏技术等相关专业国家统招本科及以上学历。
                        </li>
                        <li>
                            2、3年以上同岗位工作经验，具有丰富的本专业设计经验及研发经验。
                        </li>
                        <li>3、熟练掌握本专业的基本理论知识，掌握暖通、空调等自控系统的设计原理及设计流程，能独立完成设计工作。</li>
                        <li>
                            4、熟练运用Office、Auto CAD等计算机软件系统。
                        </li>
                        <li>
                            5、为人诚恳正直、踏实努力，具有良好的团队合作精神。
                        </li>
                        <li>6、具有设计院或节能研究院工作经历、中级以上职称者优先考虑。</li>
                    </ul>
                </div>
            </div> -->
            <!-- <div class="panel">
                <div class="panel-heading">
                    <h3 class="panel-title">unity3D工程师</h3>
                </div>
                <div class="panel-body">
                    <div class="duty-desc">职位描述</div>
                    <ul>
                        <li class="pos-desc">岗位职责：</li>
                        <li>
                            1、针对产品经理提出的项目方案和需求规划，制定系统的整体框架，包括技术框架和业务框架;
                        </li>
                        <li>
                            2、对系统框架和相关技术进行培训，指导开发人员开发，解决实际开发过程中遇到的技术问题。
                        </li>
                        <li>3、负责软件整体功能开发。</li>
                        <li class="pos-desc">任职资格：</li>
                        <li>1、计算机或自动化相关专业，本科以上学历;</li>
                        <li>2、熟悉虚拟现实技术，了解三维图形知识;</li>
                        <li>
                            3、具有3年以上从事能源管理或工厂数字化系统开发的工作经验，参加过大中型系统开发工作；
                        </li>
                        <li>
                            4、熟练C++，C#编程技术，架构过类似的软件产品并以投入使用;
                        </li>
                        <li>5、熟悉unity3D图形开发引擎及相关知识。</li>
                    </ul>
                </div>
            </div> -->
            <div class="panel">
                <div class="panel-heading">
                    <h3 class="panel-title">高级算法开发工程师</h3>
                </div>
                <div class="panel-body">
                    <div class="duty-desc">职位描述</div>
                    <ul>
                        <li class="pos-desc">岗位职责：</li>
                        <li>
                            1、负责制冷系统、供热系统、空压系统、工艺系统等工厂重要子系统控制策略编写、参数整定；
                        </li>
                        <li>
                            2、通过控制算法的优化实现制冷系统、供热系统、空压系统、工艺系统等工厂重要子系统的节能、稳定、安全、稳定的运行；
                        </li>
                        <li>
                            3、负责公司已运行制冷系统、供热系统、空压系统、工艺系统等工厂重要子系统的前馈控制、负荷在线预测和公司已有工厂数字化管理系统的控制算法优化；
                        </li>
                        <li>
                            4、对工厂内设备和人行为状态算法分析，完善现有的工厂数字化管理系统；
                        </li>
                        <li>5、基于大数据的控制算法优化的研究；</li>
                        <li>6、研究国内外该方向的发展趋势</li>
                        <li class="pos-desc">任职资格：</li>
                        <li>
                            1、211或者985大学统招本科以上相关专业毕业，2年及以上工作经验；
                        </li>
                        <li>
                            2、有两年以上先进控制算法的工作经验，具有扎实的经典控制及现代控制理论基础或扎实的系统辨识的基础；
                        </li>
                        <li>
                            3、熟悉C/C++语言编程，对MATLAB或python精通者优先考虑，能够熟悉阅读与翻译英文技术资料；
                        </li>
                        <li>
                            4、良好的沟通能力和团队合作精神，能与客户、暖通动力技术人员进行有效沟通。
                        </li>
                    </ul>
                </div>
            </div>
            <!-- <div class="panel">
                <div class="panel-heading">
                    <h3 class="panel-title">电气工程师</h3>
                </div>
                <div class="panel-body">
                    <div class="duty-desc">职位描述</div>
                    <ul>
                        <li class="pos-desc">任职资格：</li>
                        <li>1、本科以上学历，三年以上工作经历；</li>
                        <li>
                            2、工厂FMCS系统包括锅炉房，冷水机组、空压机组，工艺空调机组、水系统的电气控制的设计以及工厂EMS系统设计；
                        </li>
                        <li>
                            3、生物安全实验室和理化实验室自动化及数字化系统设计；
                        </li>
                        <li>4、工厂工艺自动化系统设计；</li>
                        <li>
                            5、熟悉工厂的动力或生产工艺，熟练进行电气原理图绘制，电气控制柜布置，接线图的设计；
                        </li>
                        <li>
                            6、熟悉电气布线，电气部件标准机选型，熟悉变频器，电气自动化控制及仪表的标准及选型；
                        </li>
                        <li>7、指导工程安装及现场电气问题的处理和协调；</li>
                        <li>8、有中级电气工程师、注册电气工程师证书优先。</li>
                    </ul>
                </div>
            </div> -->
            <!-- <div class="panel">
                <div class="panel-heading">
                    <h3 class="panel-title">PLC编程工程师</h3>
                </div>
                <div class="panel-body">
                    <div class="duty-desc">职位描述</div>
                    <ul>
                        <li>
                            1、根据控制系统功能要求编写PLC程序，完成控制系统调试。
                        </li>
                        <li class="pos-desc">岗位职责：</li>
                        <li>1、 负责电气及自动化控制的设计、PLC编程；</li>
                        <li>
                            2、 工厂生产设备（线）电气及控制系统的维护、调试；
                        </li>
                        <li>
                            3、
                            工厂及商业楼宇暖通动力设备（线）电气及控制系统的维护、调试；
                        </li>
                        <li>
                            4、熟练使用SIEMENS 或AB
                            PLC；熟练使用变频器、各种相关传感器;
                        </li>
                        <li>
                            5、解决技术问题，参加现场试验并处理电气故障，提出产品改进措施
                        </li>
                        <li class="pos-desc">任职资格：</li>
                        <li>
                            1、自动控制、电子电气工程、制药、暖通等专业，本专及以上学历；
                        </li>
                        <li>2、具有2年以上大型自动化系统编程调试经验；</li>
                        <li>
                            3、具备电气、自动控制相关知识；能够使用Protel，CAD等软件；
                        </li>
                        <li>
                            4、熟悉电气标准，熟练使用工程设计图纸，对于电气接线图，原理图能够熟练阅读、绘制。
                        </li>
                        <li>
                            5、熟悉工厂生产工艺，暖通动力工艺，供配电系统等系统控制者优先。
                        </li>
                    </ul>
                </div>
            </div> -->
            <!-- <div class="panel">
                <div class="panel-heading">
                    <h3 class="panel-title">自控项目经理</h3>
                </div>
                <div class="panel-body">
                    <div class="duty-desc">职位描述</div>
                    <ul>
                        <li class="pos-desc">岗位职责：</li>
                        <li>
                            1、全面负责项目的技术支持和管理工作，协调公司内部资源.外部资源和用户需求完成项目的支持.实施.调试.培训.验收.交付和运维；
                        </li>
                        <li>
                            2、负责与工程项目支持.实施和交付相关的技术文档和图纸编制；包括施工方案.料单核算.变更.调试.验收.培训资料等；
                        </li>
                        <li>3、负责案例和用户资料的整理.分析.总结。</li>
                        <li class="pos-desc">任职资格：</li>
                        <li>
                            1、一本统招以上学历，机电.自动化及管理类相关专业，有获得项目管理资质认证者优先；
                        </li>
                        <li>
                            2、有3年以上自动化工程（PLC.工业网络等）实施和管理经验，有FMCS/BMS/DCS自动化项目管理经验者优先；
                        </li>
                        <li>
                            3、具有较强的内.外部沟通能力.计划制定及资源协调能力。逻辑思维清晰，能够很好的推进项目进度，管控项目节点。能独立完成BMS或FMCS或DCS自动化系统方案；
                        </li>
                        <li>
                            4、能够熟练应用项目管理软件，如Project等；能独立完成项目文档的编写和系统功能模块设计；
                        </li>
                        <li>5、具有良好的沟通能力和逻辑思维能力；</li>
                        <li>
                            6、具有良好的团队协作和抗压能力，能适应中期出差。
                        </li>
                    </ul>
                </div>
            </div> -->
              <!-- <div class="panel">
                <div class="panel-heading">
                    <h3 class="panel-title">自控维保工程师</h3>
                </div>
                <div class="panel-body">
                    <div class="duty-desc">职位描述</div>
                    <ul>
                        <li class="pos-desc">岗位职责：</li>
                        <li>
                           1、根据工程项目需求，现场勘查，完成仪表的安装等工作；
                        </li>
                        <li>
                           2、能完善项目需要的基础资料和仪表专业图纸并提出建议方案；
                        </li>
                        <li>3、能简单运用西门子PLC的编程软件和WINCC等组态软件；</li>
                        <li>4、了解大型中央空调及恒温恒湿控制系统；</li>
                        <li>5、精通热工元件的工作原理：如压力变送器、压力开关、温度探头PT100及温度传感器等；</li>
                        <li>6、熟悉空调PI&D图纸及简单的电气控制的二次回路原理及回路调试。</li>
                        <li class="pos-desc">任职资格：</li>
                        <li>
                            1、大学本科及以上，计算机、自动化等工科类专业；
                        </li>
                        <li>
                            2、年龄 45 岁以下；
                        </li>
                        <li>
                            3、根据工作需要，接受甲方的工作安排；
                        </li>
                        <li>
                           4、品行端正，无不良嗜好：如酗酒等；
                        </li>
                        <li>5、本岗位需要上夜班。</li>
                    </ul>
                </div>
            </div> -->
            <div class="panel">
                <div class="panel-heading">
                    <h3 class="panel-title">销售经理</h3>
                </div>
                <div class="panel-body">
                    <div class="duty-desc">职位描述</div>
                    <ul>
                        <li class="pos-desc">岗位职责：</li>
                        <li>1、负责制定项目的销售计划和目标；</li>
                        <li>2、掌握市场动态，积极开拓市场、完成销售目标；</li>
                        <li>
                            3、对外沟通，对市场进行分析，选择合适的开发渠道；
                        </li>
                        <li class="pos-desc">任职资格：</li>
                        <li>
                            1、工作认真、积极、谨慎、有热情、细心、责任心强、学习能力强；
                        </li>
                        <li>2、有较强的沟通、协调能力，优秀的外联公关能力；</li>
                        <li>3、掌握完善的销售技巧，具备优秀的沟通能力；</li>
                        <li>
                            4、具备大学本科工科学习的背景，有生物制药、半导体、暖通动力、弱电行业、自动化、数字化行业工作背景
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {}
</script>

<style scoped lang="less">
.recruit-content {
    margin: 42px auto 0;
}
.panel {
    border-radius: 12px;
    box-shadow: none;
    padding: 0 45px 35px;
    margin-bottom: 30px;
    .panel-heading {
        padding: 32px 0 0;
        border-bottom: 1px solid #e6e8f2;
        height: 80px;
        .panel-title {
            color: #333333;
            font-size: 26px;
        }
    }
    .panel-body {
        padding: 0;
        margin-bottom: 20px;
        ul {
            li {
                font-size: 14px;
                color: #020e1f;
                line-height: 22px;
            }
        }
        .duty-desc {
            color: #020e1f;
            line-height: 42px;
            font-size: 18px;
            margin-top: 25px;
        }
        .pos-desc {
            line-height: 42px;
            margin-bottom: -6px;
        }
    }
}
</style>
